import { QRCodeSVG } from 'qrcode.react';

import { BottomSheet } from '~/modules/elements/akui/bottom-sheet';
import buildRoomLink from '~/modules/utils/build-room-link';

interface Props {
  open: boolean;
  onClose: () => void;
  roomId: string | null;
}

export default function AddPhoneSheet({ open, onClose, roomId }: Props) {
  const code = roomId ?? '';
  const link = buildRoomLink('remote-mic', code);

  return (
    <BottomSheet open={open} onClose={onClose} title="Add another phone">
      <div className="flex flex-col items-center gap-3.5">
        <div className="flex size-54 items-center justify-center rounded-[1.125rem] bg-white p-3">
          <QRCodeSVG value={link} width="100%" height="100%" marginSize={0} />
        </div>
        <span className="text-[0.9375rem] text-white/60">{new URL(link).host}</span>
        <span data-test="game-code" className="text-active text-[2.125rem] font-bold tracking-[0.1em]">
          {code.toUpperCase()}
        </span>
      </div>
    </BottomSheet>
  );
}
